import '../../styles/common.scss';
import privacyPolicy from './PrivacyPolicy';

export default function PrivacyPolicyContainer() {

    const privacyData = privacyPolicy.data[0].attributes;

    return (<>
      <div className='hygiene_wrapper'>
        <p className='title'>
          {privacyData?.pageTemplates[0]?.heading}
        </p>
  
        <p className='description'>
          {privacyData?.pageTemplates[0]?.description}
        </p>
  
        <div className='content'>
          {privacyData?.pageTemplates[0]?.sections?.map((item: any, index: number) => (
            <div className='content' key={"privacy_" + index}>
              <p className='subtitle'>{item?.title}</p>
              <p className='description'>{item?.description}</p>
            </div>
          ))}
        </div>
      </div>
      </>
    );
  }